"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = modal;

var _merge = require("lodash/merge");

var _merge2 = _interopRequireDefault(_merge);

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Modal reducer is used for showing & hiding modals, as well as passing data to modals. For a
// modal to be rendered, it must have a constant mapped to the component in constants/modalTypes.
//
// modal.component: constant representing component to be rendered
// modal.props: single object to be passed to modal component as props
// modal.result: name of action with notifyModal: true will be set here so modal knows when
//               relevant actions have completed

if (!global._babelPolyfill) {
    require("babel-polyfill");
}
function modal() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { all: {}, result: {} };
    var action = arguments[1];

    var nextState = void 0;

    if (action.type === actionTypes.SHOW_MODAL) {
        var newModal = {
            component: action.component,
            props: action.props
        };
        return _extends({}, state, {
            all: _extends({}, state.all, _defineProperty({}, action.component, newModal))
        });
    } else if (action.type === actionTypes.DISMISS_MODAL) {
        if (action.component) {
            var all = state.all;

            delete all[action.component];
            return _extends({}, state, {
                all: _extends({}, all)
            });
        } else {
            return _extends({}, state, {
                all: {}
            });
        }
    } else if (action.notifyModal) {
        return _extends({}, state, {
            result: { actionType: action.type, error: action.error }
        });
    } else {
        return state;
    }

    return nextState;
}